import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface DemoRequest {
  name: string;
  email: string;
  /** Opcional: vazio quando não informado. */
  phone: string;
  institution: string;
  role: string;
  consent: boolean;
  /** Campo isca contra robôs: fica oculto e deve seguir vazio. */
  website: string;
}

/**
 * Envia a solicitação de demonstração para a API do site (Lambda + AWS SES, ver infra/contato.tf).
 * O destinatário é definido no servidor: todo e-mail vai para medviz@medviz.com.br.
 */
@Injectable({ providedIn: 'root' })
export class DemoRequestService {
  private readonly http = inject(HttpClient);

  async submit(request: DemoRequest): Promise<void> {
    await firstValueFrom(this.http.post('/api/contato', request));
  }
}
